import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { NewDesignButtonV2, NewDocumentButtonV2, WizardButton } from '../WizardButton/WizardButton'
import { HighDetailedSearch } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { WizardListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import { ChannelKeyType } from '../Types'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

export const SearchSection = ({ search, searchResults, ...props }: SectionProps) => {
  if (searchResults?.length === 0)
    return (
      <div className={Styles.emptySearchContainer}>
        <HighDetailedSearch size={70} />
        <div className={Styles.emptySearchText}>
          <Heading level={3}>We couldn't find anything for</Heading>
          <Text>{`"${search}"`}</Text>
        </div>
        <div className={Styles.newFileContainer}>
          <NewDesignButtonV2 title="Start with a Blank Design" size="lg" />
          <NewDocumentButtonV2 title="Start with a Blank Doc" size="lg" />
        </div>
      </div>
    )

  const wizardsHeading = `Results for '${search}'`

  return (
    <div className={Styles.commonSectionContainer}>
      <ResponsiveDesign.Mobile>
        <WizardListItemContainer wizards={searchResults as ChannelKeyType[]} heading={wizardsHeading} {...props} />
      </ResponsiveDesign.Mobile>

      <ResponsiveDesign.Desktop>
        <>
          <Heading level={3}>{wizardsHeading}</Heading>
          <div className={Styles.wizardGroup}>
            {searchResults?.map((channelKey) => (
              <WizardButton key={channelKey} channelKey={channelKey} size="lg" {...props} version={2} />
            ))}
          </div>
        </>
      </ResponsiveDesign.Desktop>
    </div>
  )
}
